import React from "react";
import { Box } from "@mui/material";
import { Stream } from "@cloudflare/stream-react";
import { validateYouTubeUrl } from "gatsby-frontend";
import { validateVimeoUrl } from "gatsby-frontend";

function Player({ url, poster, cloudflare, autoplay = true }) {
	const YouTubeID = validateYouTubeUrl(url);
	const VimeoID = !YouTubeID ? validateVimeoUrl(url) : null;
	let embed;
	if (YouTubeID || VimeoID) {
		let embed_attrs = {};
		if (YouTubeID) {
			embed_attrs.src = `https://www.youtube.com/embed/${YouTubeID}${
				autoplay ? "?autoplay=1" : ""
			}`;
			embed_attrs.allow = `accelerometer; ${
				autoplay ? "autoplay;" : ""
			} clipboard-write; encrypted-media; gyroscope; picture-in-picture`;
		} else if (VimeoID) {
			embed_attrs.src = `https://player.vimeo.com/video/${VimeoID}${
				autoplay ? "?autoplay=1" : ""
			}`;
			embed_attrs.allow = `${
				autoplay ? "autoplay;" : ""
			} fullscreen; picture-in-picture`;
		}
		embed = (
			<iframe
				{...embed_attrs}
				width="640"
				height="360"
				frameborder="0"
				allowfullscreen
			></iframe>
		);
	} else if (cloudflare) {
		embed = <Stream controls autoplay={autoplay} src={cloudflare} />;
	} else {
		let embed_attrs = {};
		if (autoplay) {
			embed_attrs.autoPlay = true;
			embed_attrs.muted = true;
		}
		embed = (
			<video width="320" height="240" controls poster={poster} {...embed_attrs}>
				<source src={url} type="video/mp4" />
				Your browser does not support the video tag.
			</video>
		);
	}
	return (
		<Box
			sx={(theme) => ({
				width: "100%",
				paddingTop: "56%",
				backgroundColor: theme.palette.grey["800"],
				"& iframe, & video": {
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
				},
				"& > div": {
					position: "static !important",
					paddingTop: `0 !important`,
				},
			})}
		>
			{embed}
		</Box>
	);
}

export default Player;
